import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ImportHistoryTable from './table/ImportHistoryTable'
import ImportsLoader from './_load/ImportsLoader'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ImportHistoryModal = props => {
  return (
    <ControlledModal width="58rem" {...props}>
      <ModalHeader />
      <Separator weight={4} />
      <FilterHandler>
        <ImportsLoader>
          <ImportHistoryTable />
        </ImportsLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default ImportHistoryModal
